var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fa-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.gender),expression:"gender"}],attrs:{"icon":_vm.icon,"title":_vm.gender,"transform":"grow-3"}})}
var staticRenderFns = []

export { render, staticRenderFns }